module.exports = __webpack_public_path__ + "img/kh.e045547f.svg";